<template>
    <div>
      <h2 class="text-xl font-bold mb-4">Selecciona el enfoque de la entrevista</h2>
      <div class="flex gap-4">
        <button
          :class="{
            'bg-gray-300 hover:bg-gray-400': selectedFocus !== 'habilidades',
            'bg-blue-500 hover:bg-blue-700 text-white': selectedFocus === 'habilidades'
          }"
          class="font-bold py-2 px-4 rounded"
          @click="selectFocus('habilidades')"
        >
          Foco en Habilidades
        </button>
        <button
          :class="{
            'bg-gray-300 hover:bg-gray-400': selectedFocus !== 'experiencia',
            'bg-blue-500 hover:bg-blue-700 text-white': selectedFocus === 'experiencia'
          }"
          class="font-bold py-2 px-4 rounded"
          @click="selectFocus('experiencia')"
        >
          Foco en Experiencia
        </button>
        <button
          :class="{
            'bg-gray-300 hover:bg-gray-400': selectedFocus !== 'balanceada',
            'bg-blue-500 hover:bg-blue-700 text-white': selectedFocus === 'balanceada'
          }"
          class="font-bold py-2 px-4 rounded"
          @click="selectFocus('balanceada')"
        >
          Balanceada
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: ['setInterviewFocus'],
    data() {
      return {
        selectedFocus: null, // Inicializamos como null, indicando que ningún botón está seleccionado
      };
    },
    methods: {
      selectFocus(focus) {
        this.selectedFocus = focus;
        this.setInterviewFocus(focus);
      },
    },
  };
  </script>